import React, { useEffect } from "react";
import { useLayoutContext } from "@ntg/component-library/contexts";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function UserLogins() {
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
        useEffect(() => {
            SetPrimaryTitle("USER LOGINS");
            SetSecondaryHeader(null);
            return () => {
                SetPrimaryTitle("");
                SetSecondaryHeader(null);
            };
        }, [SetPrimaryTitle, SetSecondaryHeader]);

    return (
        <Box alignItems={"center"} display="flex" flexDirection="row" gap={7} justifyContent={"left"} p={2} >
            <Typography
                sx={{ paddingLeft: "16px" }}
                variant="body1"
            >USER LOGINS BODY</Typography>
        </Box>
    );
}